import {DatePipe} from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';
// eslint-disable-next-line
import * as moment from 'moment-timezone';

@Pipe({
  name: 'momentDate'
})
export class MomentDatePipe extends DatePipe implements PipeTransform {
  transform(value: string | Date, format = 'dd.MM.yyyy HH:mm', timezone = 'Europe/Berlin'): any {
    const timezoneOffset = moment(value).tz(timezone).format('Z');
    return super.transform(value, 'dd.MM.yyyy, HH:mm', timezoneOffset);
  }
}
